import React, { ReactElement } from 'react';

import useDiscardChangesModalContainer from 'adapter/in/dashboards/containers/Modals/DiscardChangesModal/useDiscardChangesModal';
import ConfirmActionModal from 'adapter/in/common/components/ConfirmActionModal/ConfirmActionModal';
import i18n from 'asset/translation';

import gtmIds from 'adapter/in/dashboards/config/gtm';

const gtm = gtmIds.dashboard.confirmChangesModal.actions;

const EditDashboardPageDiscardChangesModalContainer = (): ReactElement => {
    const { onModalAbortChanges, onModalCancel, modalDiscardChanges, onModalSaveAndProceed } = useDiscardChangesModalContainer();

    return (
        <ConfirmActionModal
            optionalButton={onModalSaveAndProceed}
            mainButton={onModalAbortChanges}
            onClose={onModalCancel}
            isOpen={modalDiscardChanges.show}
            message={i18n.t('dashboards.edit.discardChangesModalText')}
            mainButtonText={i18n.t('dashboards.edit.discardChangesModalDiscard')}
            title={i18n.t('dashboards.edit.discardChangesModalTitle')}
            optionalButtonText={i18n.t('dashboards.edit.discardChangesModalSaveAndProceed')}
            mainButtonVariant='destructive'
            dataIdContext={gtm}
        />
    );
};

export default EditDashboardPageDiscardChangesModalContainer;
